import React from "react";
import { cn } from "../../lib/utils";

export const ShimmerButton = React.forwardRef(function ShimmerButton(
  {
    className,
    children,
    shimmerColor = "rgba(103, 232, 249, 0.9)",
    shimmerSize = "1px",
    shimmerDuration = "3s",
    borderRadius = "0.95rem",
    background = "linear-gradient(180deg, rgba(20,30,52,.98) 0%, rgba(7,11,24,.98) 100%)",
    type = "button",
    ...props
  },
  ref
) {
  const resolvedBackground = background || "linear-gradient(180deg, rgba(20,30,52,.98) 0%, rgba(7,11,24,.98) 100%)";

  return (
    <button
      ref={ref}
      type={type}
      style={{
        "--spread": "90deg",
        "--shimmer-color": shimmerColor,
        "--radius": borderRadius,
        "--speed": shimmerDuration,
        "--cut": shimmerSize,
        "--bg": resolvedBackground
      }}
      className={cn(
        "group relative inline-flex cursor-pointer items-center justify-center overflow-hidden whitespace-nowrap rounded-[var(--radius)] border border-white/10 px-4 py-2 text-sm font-semibold text-slate-100 [background:var(--bg)] shadow-[0_0_0_1px_rgba(15,23,42,.55),0_8px_24px_rgba(2,6,23,.32)] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_14px_34px_rgba(2,6,23,.42)]",
        className
      )}
      {...props}
    >
      <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden rounded-[inherit]">
        <div className="absolute inset-[-140%] animate-spin-around bg-[conic-gradient(from_calc(270deg-(var(--spread)*0.5)),transparent_0,var(--shimmer-color)_var(--spread),transparent_var(--spread))]" />
      </div>
      <div aria-hidden className="pointer-events-none absolute inset-[var(--cut)] rounded-[calc(var(--radius)-var(--cut))] [background:var(--bg)]" />
      <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden rounded-[inherit]">
        <div className="absolute inset-y-0 left-[-140%] w-[140%] animate-shimmer-slide bg-[linear-gradient(90deg,transparent,rgba(255,255,255,0.28),transparent)]" />
      </div>
      <span className="relative z-10">{children}</span>
    </button>
  );
});
